import React from 'react';

function Loader() {
  return <div className="loading small" />;
}

export default Loader;
